export default "__VITE_ASSET__9897b3c1__"